import {
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  Tooltip,
} from '@material-ui/core';
import Menu, { MenuProps } from '@material-ui/core/Menu';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import React, { Fragment, memo, ReactElement, useState } from 'react';

type ListMenuItem = {
  title: string;
  icon?: ReactElement;
  onClick?: VoidFunction;
  disabled?: boolean;
  disabledTooltip?: string;
};

export interface DropDownListMenuItem extends ListMenuItem {
  subMenuItems?: ListMenuItem[];
}

interface Props extends Omit<MenuProps, 'onClose'> {
  title: string;
  onClose?: VoidFunction;
  children: DropDownListMenuItem[];
}

const DropDownListMenu = ({ title, onClose, children, ...props }: Props) => {
  const [indexOpen, setIndexOpen] = useState<number>(-1);

  const handleClickDropDown = (index: number) => () => {
    setIndexOpen(indexOpen === index ? -1 : index);
  };

  return (
    <Menu onClose={onClose} {...props}>
      <List
        component="nav"
        aria-labelledby="nested-list-subheader"
        subheader={
          <ListSubheader component="div" id="nested-list-subheader">
            {title}
          </ListSubheader>
        }
      >
        {children.map(
          (
            {
              disabled,
              onClick,
              subMenuItems,
              title,
              icon,
              disabledTooltip = '',
            },
            index
          ) => (
            <Fragment key={index}>
              <Tooltip title={disabled ? disabledTooltip : ''}>
                <span>
                  <ListItem
                    button
                    disabled={disabled}
                    onClick={
                      subMenuItems && subMenuItems.length > 0
                        ? handleClickDropDown(index)
                        : onClick
                    }
                  >
                    {icon && <ListItemIcon>{icon}</ListItemIcon>}
                    <ListItemText primary={title} />
                    {subMenuItems &&
                      subMenuItems.length > 0 &&
                      (indexOpen === index ? <ExpandLess /> : <ExpandMore />)}
                  </ListItem>
                </span>
              </Tooltip>
              {subMenuItems && subMenuItems.length > 0 && (
                <Collapse in={indexOpen === index} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {subMenuItems.map((subLi, index) => (
                      <ListItem key={index} button onClick={subLi.onClick}>
                        {subLi.icon && (
                          <ListItemIcon>{subLi.icon}</ListItemIcon>
                        )}
                        <ListItemText
                          inset={!subLi.icon}
                          primary={subLi.title}
                        />
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              )}
            </Fragment>
          )
        )}
      </List>
    </Menu>
  );
};

export default memo(DropDownListMenu);
